import {Component} from './component';
import {testColorIndicatorWidth} from './index.styled';

export const TestColorIndicator = Object.assign(Component, {
	testColorIndicatorWidth,
});
